<template>
    <div class="modal fade" tabindex="-1" :id="id">
        <div class="modal-dialog modal-lg">
          <form id="kt_modal_form_project" @submit.prevent="updateProject" class="form mt-5" >
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">{{ $t('projects.update_project') }}</h5>
                <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                  <span class="svg-icon svg-icon-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                            fill="currentColor"/>
                      <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                            fill="currentColor"/>
                    </svg>
                  </span>
                </div>
              </div>
              <div class="modal-body">
                <ProjectForm
                    :form="formEditData"
                    :id="id"
                    :categories="categories"
                    :has-progress="true"
                    :has-cat="!!formEditData?.project_category_id"
                    :has-detail="!!formEditData?.description"
                    :openCustomerStatusModal="openCustomerStatusModal"
                    :openContactModal="openContactModal"
                />
              </div>
              <div class="modal-footer">
                <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
                <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoading"></Button>
              </div>
            </div>
          </form>
        </div>
      </div>

    <CustomerStatusFormModal id="customerStatCreateModal" @callback="afterCreateStatus" :parent-id="id" />
    <div class="modal fade" tabindex="-1" id="customerContactCreateModal">
      <div class="modal-dialog modal-xl">
        <create-contact id="customerContactCreateModal"
                        :get-countries="getCountries"
                        :get-currencies="getCurrencies"
                        :contact="formCreateContactData"
                        :modal="true"
                        :parent="id"
                        @success="afterCreateContact">
        </create-contact>
      </div>
    </div>

    <div class="modal fade" tabindex="-1" id="companyCreateModal">
      <div class="modal-dialog modal-xl">
        <create-contact id="companyCreateModal" :get-countries="getCountries" parent="customerContactCreateModal" :get-currencies="getCurrencies" :contact="formCreateCompanyData" :modal="true"
                        @success="chargeContacts">
        </create-contact>
      </div>
    </div>

    <PostFormModal @postOffice="selectPosts" id="postCreateModal" parent="companyCreateModal" ></PostFormModal>

</template>

<script setup>

import { defineProps,onMounted,ref, watch } from 'vue';
import { useStore } from "vuex";
import Button from "@/components/Button.vue"
import { computed } from 'vue';
import ProjectForm from './ProjectForm.vue';
import CategoryModal from "../../Modals/CategoryModal"
import CreateContact from "@/components/contact/CreateContact.vue";
import CustomerStatusFormModal from "@/Modules/Projects/components/Modals/CustomerStatus/CustomerStatusFormModal.vue";
import PostFormModal from "@/components/Post/postModal.vue";

const props = defineProps({
  id:{
    type: String, 
    default: "update_project_modal"
  },
  form: {
    type: Object,
    default: {
      id: '',
      title: '',
      reference: '',
      start_date: '',
      end_date: '',
      description: '',
      key_word: [],
      creation_date: '',
      closing_date: '',
      contact_id: '',
      project_category_id: '',
      manager_id: '',
      office_id: '',
      budget_name: '',
      forecast_budget: '',
      currency_id: '',
      allow_dispatch: false,
      users: []
    }
  },
  office:{
    type: String, 
    default: ""
  }
})

const emit = defineEmits(['reloadDatatable'])

const store = useStore()

const formEditData = ref(props.form)
const currentCustomer = ref(0)
const formCreateContactData = ref({
  id: null,
  gender: null,
  contactType: 'particular',
  lastname: null,
  firstname: null,
  address: {
    street: null,
    street2: null,
    city: null,
    zipcode: null,
    country: null
  },
  customer: true,
  birthday: null,
  supplier: false,
  telephone: [],
  avatar: null,
  email: null,
  website: null,
  currency_id: '',
  post_id:null,
  company_id: null,
  enable_portal: false,
  collaborators: [],
  exchange_rate: 1,
})

const formCreateCompanyData = ref({
  id: null,
  gender: null,
  contactType: 'particular',
  lastname: null,
  firstname: null,
  address: {
    street: null,
    street2: null,
    city: null,
    zipcode: null,
    country: null
  },
  customer: true,
  birthday: null,
  supplier: false,
  telephone: [],
  avatar: null,
  email: null,
  website: null,
  currency_id: '',
  post_id:null,
  company_id: null,
  enable_portal: false,
  collaborators: [],
  exchange_rate: 1,
})

const categories = computed(() => store.getters['projectCategories/getProjectCategories'])
const getCountries = computed(() => store.getters['countries/getCountries'])
const getCurrencies = computed(() => store.getters['company/getCurrencies'])

const isLoading = ref(false)

watch(() => props.office, (value) => {
  if(value) formEditData.value.office_id = value
})

watch(() => props.form, (value) => {
  if(value) formEditData.value = {...props.form,office_id: props.office }
}, {deep: true})

function closeModal(){
  formEditData.value = null
  formEditData.value = {
    title: '',
    reference: '',
    start_date: '',
    end_date: '',
    description: '',
    key_word: [],
    creation_date: '',
    closing_date: '',
    contact_id: '',
    project_category_id: '',
    manager_id: '',
    office_id: props.office,
    budget_name: '',
    forecast_budget: '',
    currency_id: '',
    users: []
  }
  $('#'+props.id).modal('toggle')
}

async function updateProject() {
    isLoading.value = true
    try{
      await store.dispatch('projects/updateProject', formEditData.value).then((res) => {
        emit('reloadDatatable')
        closeModal()
        window.toastr.success(i18n.global.t("projects.project_updated_successfully"))
        formEditData.value = {}
        isLoading.value = false
      })
    }catch(err){
      isLoading.value = false
    }
}

function openCustomerStatusModal(index) {
  currentCustomer.value = index
  $("#"+props.id).modal('toggle')
  $("#customerStatCreateModal").modal('toggle')
}
function afterCreateStatus(status) {
  $("#itemTaxCreateModal").modal('toggle')
  formEditData.value.contacts[currentCustomer.value].contact_status_id = status.id
}
function openContactModal(index){
  currentCustomer.value = index
  $('#'+props.id).modal('toggle')
  $("#customerContactCreateModal").modal('toggle');
}
function afterCreateContact(contact) {
  $("#customerContactCreateModal").modal('toggle')
  formEditData.value.contacts[currentCustomer.value].contact_id = contact.id
}
async function chargeContacts(contact, select=false) {
  if(contact && select){
    formCreateContactData.value.collaborators.push(contact.id)
    formCreateContactData.value.company_id = contact.id
  }
}

function selectPosts(post){
  formCreateContactData.value.post_id = post
}


onMounted(() => {
  Promise.all([
    store.dispatch("projectCategories/loadProjectCategories"),
    store.dispatch("contacts/loadContacts"),
    store.dispatch("user/loadUsers"),
    store.dispatch('currencies/loadCurrencies'),
    store.dispatch('customerStatus/loadCustomerStatus')
  ])
      .then()
      .finally()

})
</script>

<style scoped>
.modal-body {
  max-height: 75vh;
  overflow-y: auto;
  overflow-x: hidden;
  scroll-behavior: smooth;
}

</style>
